import { styled } from "stitches.config";
import Typography from "../sushi/Typography";

export type SimulatorLegendProps = {
    items: {
        color: string;
        label: string;
    }[];
}

export const SimulatorLegend = ({items}: SimulatorLegendProps) => {
    return (
      <LegendContainer>
        {items.map(item => (
          <ItemContainer key={item.label}>
            <ItemCircle style={{ backgroundColor: item.color }} />
            <Typography variant="bodyS">
              {item.label}
            </Typography>
          </ItemContainer>
        ))}
      </LegendContainer>
    )
}

const LegendContainer = styled('div', {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    gap: '$6',
});

const ItemContainer = styled('div', {
    display: 'flex',
    alignItems: 'center',
    gap: '$2',
});
  
const ItemCircle = styled('div', {
    height: '8px',
    width: '8px',
    borderRadius: '50%',
});